<template>
    <ValidationProvider v-slot="{ errors }" name="ClaimRef" rules="required">
      <AdvancedDropdown 
        v-model="modelValue" 
        v-bind="$attrs" 
        :options="options" 
        :disabled="false" 
        :can-add-new="false"
        label="ClaimRef" 
        size="sm"
        :loading="loading  && options.length === 0"

      >
        <template v-slot:label>Claim Reference <span class="text-danger">*</span></template>
  
        <template v-slot:button-content>
          <template v-if="!!selectedOption">{{ selectedOption.text }}</template>
          <template v-else>Select</template>
        </template>
      </AdvancedDropdown>
  
      <div v-if="!!errors.length" class="invalid-feedback d-block">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'
  import { ValidationProvider } from 'vee-validate'
  import Vue from 'vue'
  import { BaseIcon } from '@components/base'
  import { AdvancedDropdown } from '@components/advanced'
  
  export default defineComponent({
    name: 'CashCallFormClaimRef',
    components: {
      ValidationProvider,
      BaseIcon,
      AdvancedDropdown
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      }
    },
    emits: ['input'],
    data() {
    return {
      loading: false, 
    }
    },
    mounted() {
      Vue.prototype.$emitter.on('claims-loaded', ({ status }) => {
        this.loading = false
      })
    },
    computed: {
      modelValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$emit('input', newValue)
          this.$emit('claimref-change', newValue) // custom event
        }
      },
      selectedOption() {
        const val = this.value[0]
        if (!val) return null
        //this.$emit('claimref-change', this.value)
        return this.options.find(opt => opt.value === val) || null
      }
    }
  })
  </script>